import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import PropTypes from "prop-types";
import React from "react";
import environment from "web/script/modules/environment";
import { EU_COUNTRIES } from "../../constants";
import LegalAgreement from "../legal-agreement/legal-agreement";
import Button from "../button/button";
import styles from "./email-capture-form.css";

export function EmailCaptureForm({
    captureType,
    emailAddress,
    emailLabelText,
    formErrors,
    onEmailChange,
    onLegalChange,
    onSubmit,
    privacyPolicyLink,
    submitText,
    termsAndConditionsLink,
    cookiePolicyLink,
    twoStepEnabled
}) {
    // legal agreements
    const country = environment.get("country");
    const isEu = EU_COUNTRIES.has(country);

    const submitButton = (
        <Button styleType="tertiary" className={styles.submitButton} type="submit" fullWidth>
            {submitText}
        </Button>
    );

    const renderedFormErrors = formErrors && formErrors.map((message, id) =>
        <div key={id} className={styles.formItemError}>
            <div dangerouslySetInnerHTML={{__html: message }} />
        </div>
    );

    return (
        <form className={styles.form} onSubmit={onSubmit}>
            <fieldset className={styles.fieldset}>
                <label className={styles.label} htmlFor="id_email">
                    {emailLabelText || gettext("account.form.email_label")}
                </label>
                <input
                    type="email"
                    name="email"
                    value={emailAddress}
                    onClick={() => analytics.event(captureType, "fill_field", "field_email")}
                    className={styles.input}
                    placeholder={gettext("account.form.email_placeholder")}
                    autoCapitalize="off"
                    onChange={onEmailChange}
                    autoFocus
                    required
                />
                {renderedFormErrors}
            </fieldset>
            {(!isEu || twoStepEnabled) && submitButton}
            <LegalAgreement
                country={country}
                submitText={submitText}
                handleLegalChange={onLegalChange}
                captureType={captureType}
                privacyPolicyLink={privacyPolicyLink}
                termsAndConditionsLink={termsAndConditionsLink}
                cookiePolicyLink={cookiePolicyLink}
                shortEUVersion={twoStepEnabled}
            />
            {(isEu && !twoStepEnabled) && submitButton}
        </form>
    );
}

export default EmailCaptureForm;

EmailCaptureForm.propTypes = {
    captureType: PropTypes.string.isRequired,
    cookiePolicyLink: PropTypes.string,
    emailAddress: PropTypes.string,
    emailLabelText: PropTypes.string,
    formErrors: PropTypes.array,
    onEmailChange: PropTypes.func.isRequired,
    onLegalChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    privacyPolicyLink: PropTypes.string.isRequired,
    submitText: PropTypes.string.isRequired,
    termsAndConditionsLink: PropTypes.string,
    twoStepEnabled: PropTypes.bool
};
